import { LockOutlined } from "@ant-design/icons"
import { Tooltip } from "antd"
import React from "react"

export function LockedLabel({ text }: { text: string }) {
  return (
    <span style={{ display: "inline-flex", alignItems: "center", gap: 6 }}>
      {text}
      <Tooltip title={"You don't have permission to change assignment"}>
        <LockOutlined
          style={{ color: "#faad14", fontSize: 13, cursor: "help" }}
        />
      </Tooltip>
    </span>
  )
}
